import { useQuery } from '@tanstack/react-query'

import { useAuth } from '@/hooks/useAuth'
import { useSupabaseClient } from '@/hooks/useSupabaseClient'
import { handleFunctionsError } from '@/lib/handleFunctionsError'
import type { OrganizationSummary } from '@/types/organization'

export const useOrganizations = () => {
  const { user } = useAuth()
  const supabase = useSupabaseClient()

  const {
    data: organizations = [],
    isPending,
    error,
  } = useQuery<OrganizationSummary[]>({
    queryKey: ['organizations', user?.id],
    enabled: !!user?.id,
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('organizations', {
        method: 'GET',
      })

      if (error) {
        await handleFunctionsError(error)
      }

      return data
    },
  })

  return { organizations, isPending: !!user?.id && isPending, error }
}
